import { Component, Input } from "@angular/core";

@Component({
  selector: "astrobin-sparkles-icon",
  templateUrl: "./sparkles-icon.component.html",
  styleUrls: ["./sparkles-icon.component.scss"]
})
export class SparklesIconComponent {
  @Input() width = 16;
  @Input() height = 16;
}
